export default __webpack_public_path__ + "static/media/dm-Icon.1e6769ef.svg";